import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Empty } from "./ui";
import { Repeat, Lock } from "lucide-react";

export default function Subscriptions() {
  const [state, setState] = useState(null);
  useEffect(() => { api.get("/admin/subscriptions").then((r) => setState(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="Abonnementen" subtitle="Terugkerende zakelijke drankbestellingen (Stripe Subscriptions)" />
      {!state?.enabled ? (
        <Card className="p-10 text-center">
          <Lock className="mx-auto text-sfc-yellow" size={44} />
          <h3 className="mt-5 font-display text-2xl text-white">Nog niet geactiveerd</h3>
          <p className="mx-auto mt-3 max-w-lg text-white/60">
            {state?.message || "Abonnementen zijn afgeschermd achter een feature flag."} Zet <code className="rounded bg-white/10 px-1.5 py-0.5 text-sfc-cyan">SUBSCRIPTIONS_ENABLED=true</code> pas nadat iDEAL/Wero-compatibiliteit voor recurring payments en de Stripe-webhooksynchronisatie zijn getest.
        </p>
        </Card>
      ) : (
        <Card>
          {state.items.length === 0 ? <Empty text="Nog geen abonnementen." /> : (
            <div className="p-6 space-y-3">
              {state.items.map((s) => (
                <div key={s.id} className="flex items-center justify-between rounded-xl bg-white/[0.03] p-4">
                  <div className="flex items-center gap-3"><Repeat className="text-sfc-lilac" size={18} /><span className="text-white">{s.company_name}</span></div>
                  <span className="text-white/60">{s.status}</span>
                </div>
              ))}
            </div>
          )}
        </Card>
      )}
    </div>
  );
}
